// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__N3C-A","sendOtp":"AuthorizeToLogin_sendOtp__3CeY9"};